type CommerceCodeParams = {
  ecommerceCode: string | null
  ecommerceTransactionHost?: string
}

export const formatCommerceCode = (params: CommerceCodeParams): string => {
  const { ecommerceCode, ecommerceTransactionHost } = params

  if (isSimulator(ecommerceCode)) {
    return 'fesimulator'
  }

  return getHostname(ecommerceTransactionHost)
}

export const isSimulator = (ecommerceCode: string | null): boolean => ecommerceCode === null

const getHostname = (ecommerceTransactionHost?: string): string => {
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname.includes('local.')

  // NOTE: need to use transactionHost for local dev as
  // *-localhost will not correctly map to b/e
  if (isLocal && ecommerceTransactionHost) {
    try {
      const url = new URL(ecommerceTransactionHost)
      return url.hostname
    } catch (_error) {
      return ecommerceTransactionHost
    }
  }
  return window.location.hostname
}
